import Icon from "@web-ui/components/Icon";
import type { Change } from "../format";

/**
 * The change against the previous period: an arrow and a word, never colour alone. The arrow
 * takes the fixed status tone (good or bad as the metric reads: more members lost is bad); the
 * words stay in the text ink.
 */
export function ChangeNote({ change, upIsGood = true, against = "vs previous" }: { change: Change; upIsGood?: boolean; against?: string }) {
  if (change.direction === "none") return <span className="text-body-2 text-t-tertiary" title={change.spoken}><span aria-hidden="true">—</span><span className="sr-only">{change.spoken}</span></span>;
  const good = change.direction === "flat" ? null : (change.direction === "up") === upIsGood;
  return (
    <span className="inline-flex items-center gap-1 text-body-2 text-t-secondary">
      {change.direction !== "flat" ? (
        <Icon name={change.direction === "up" ? "arrow-up" : "arrow-down"} size={4} className={good ? "fill-positive-stroke" : "fill-critical"} />
      ) : null}
      <span aria-hidden="true"><span className="font-medium text-t-primary tabular-nums">{change.text}</span>{change.direction !== "flat" ? ` ${against}` : ""}</span>
      <span className="sr-only">{change.spoken}</span>
    </span>
  );
}
